import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Button from '@mui/material/Button';
import React from 'react';

import { EmailSendModeDto } from '@/api/generated';
import { CustomTableAdditionalButtonProps } from '@/components/table/components/formBuilder/model/CustomTableAdditionalButtons.model.ts';
import { TimelineMessagesTableParams } from '@/components/timelineMessages/comp/confirmMessagesReadButton/model/TimelineMessagesTableParams.model.ts';
import { ResourceTimelineMessagesFormModel } from '@/components/timelineMessages/model/ResourceTimelineMessagesForm.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import {
  NEW_EMAIL_REDUCER_EVENT,
  NEW_EMAIL_VIEW_MODE,
  useNewEmailUpdateState,
} from '@/views/emails/context/NewEmails.ts';

type Props = CustomTableAdditionalButtonProps<
  ResourceTimelineMessagesFormModel,
  TimelineMessagesTableParams
>;

export const ResourceTimelineNewEmailButton: React.FC<Props> = props => {
  const { isLoading, params } = props;
  const updateNewEmailState = useNewEmailUpdateState();
  const { t } = useTranslationWithPrefix('components.timelineMessages');

  const handleClickNewEmail = () => {
    updateNewEmailState({
      payload: {
        attachments: [],
        draftRequestId: crypto.randomUUID(),
        email: null,
        mode: EmailSendModeDto.New,
        resource: params?.resource,
      },
      type: NEW_EMAIL_REDUCER_EVENT.WRITE_EMAIL,
    });
    updateNewEmailState({
      payload: { mode: NEW_EMAIL_VIEW_MODE.FLOATING_WINDOW },
      type: NEW_EMAIL_REDUCER_EVENT.CHANGE_WINDOW_MODE,
    });
  };

  return (
    <Button disabled={isLoading} onClick={handleClickNewEmail} startIcon={<EmailOutlinedIcon />}>
      {t('button.newEmail')}
    </Button>
  );
};
